import { render } from "./PartnerCollectionCode.vue?vue&type=template&id=782028bf"
import script from "./PartnerCollectionCode.vue?vue&type=script&lang=js"
export * from "./PartnerCollectionCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__